import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import { Tabs, Tab } from '@mui/material';
import VehicleTable from 'components/vehicle/VehicleTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import VehicleServices from 'services/VehicleServices';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import VehicleDrawer from 'components/drawer/VehicleDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';
import { FiPlus } from 'react-icons/fi';
import { FiRefreshCcw } from 'react-icons/fi';
import sidebar from 'routes/sidebar';

const Vehicle = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const [loading, setLoading] = useState(false);
	const { toggleDrawer, isUpdate, setIsUpdate } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [tab, setTab] = useState(0); // Default to 0 for "Unverified"
	const [error, setError] = useState(false);
	const [vehicleData, setVehicleData] = useState([]);
	const [status, setStatus] = useState(false);
	const [exportingData, setExportingData] = useState([]);
	
	const {
		vehicleRef,
		dataTable,
		serviceData,
		handleSubmitVehicle,
		currentPage,
	} = useFilter(vehicleData, itemsPerPage);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		const fetchVehicle = async () => {
			setLoading(true);
			try {
				let response;
				if (tab === 0) {
					response = await VehicleServices.getVehicleList(2); // Unverified
				} else if (tab === 1) {
					response = await VehicleServices.getVehicleList(1); // Active
				} else if (tab === 2) {
					response = await VehicleServices.getVehicleList(3); // Blocked
				} else if (tab === 3) {
					response = await VehicleServices.getVehicleList(4); // Rejected
				}
				const updatedData =
					response?.data?.map(
						({
							id,
							vendor_id,
							vehicle_name_id,
							vehicle_reg_no,
							year_of_vehicle_manufactured,
							...rest
						}) => ({
							id,
							vendor_id,
							vehicle_name_id: vehicle_name_id,
							vehicle_reg_no: vehicle_reg_no,
							year_of_vehicle_manufactured: year_of_vehicle_manufactured,
							...rest,
						})
					) || [];
					// console.log("data in updatedata", updatedData);
					
				setVehicleData(updatedData);
				setStatus(response?.status);
          
				 const finalData = response?.data?.map((item, index) => {
          return {
            "SI.No": index + 1,
            "Vendor Name": item.vendor_name, 
			"Vehicle Name": item.vehicle_name, 
			"Vehicle Type": item.vehicle_category,
			"Vehicle No": item.vehicle_reg_no,
            "Vehicle MFG Year": item.year_of_vehicle_manufactured,
			"Remark": item.cancel_add_remarks || "-",
          };
        });
        // console.log("data final", finalData);
        setExportingData(finalData);
			} catch (error) {
				console.error('Error fetching vehicle:', error);
				setError(true);
			} finally {
				setLoading(false);
			}
		};
		fetchVehicle();
		setIsUpdate(false);
	}, [tab, isUpdate]);

	const handleTabChange = (event, newValue) => {
		setTab(newValue);
	};

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'vehicle list' && perm.view === 1
		  );

	const hideDelete = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'vehicle list' && perm.delete === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'vehicle list' && perm.edit === 1
		  );

	const hideAdd = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'vehicle list' && perm.add === 1
		  );

	const hideExport = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'vehicle list' && perm.export === 1
		  );

	const handleRefresh = () => {
		setIsUpdate(true);
	};

	 const getTabName = () => {
    if (tab === 0) return "Unverified";
    if (tab === 1) return "Active";
	if (tab === 2) return "Blocked";
    if (tab === 3) return "Rejected";
    return "";
  };

	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />
					<MainDrawer>
						<VehicleDrawer id={serviceId} />
					</MainDrawer>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={vehicleRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitVehicle}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Vehicle
									</Button>
								)}

								{hideExport && (
									<ExportDataXlsx
										title="Vehicle"
										id_employee={adminInfo.id}
										exportDataXlsx={exportingData}
                                        fileNames={`Vehicle_${getTabName()}`}
									/>
								)}

								<FiRefreshCcw onClick={handleRefresh} cursor="pointer" />
							</div>
						</CardBody>
					</Card>
					<Tabs
						value={tab}
						onChange={handleTabChange}
						TabIndicatorProps={{
							style: { backgroundColor: '#057a55' },
						}}
						sx={{
							'& .MuiTab-root': {
								textTransform: 'capitalize',
							},
						}}
					>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Unverified"
						/>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Active"
						/>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Blocked"
						/>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Rejected"
						/>
					</Tabs>
					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '60vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
											<tr>
												<TableCell>Sl.No.</TableCell>
												<TableCell>Vendor Name</TableCell>
												<TableCell>Vehicle Name</TableCell>
												<TableCell>Vehicle No</TableCell>
												{tab !== 0 && tab !== 2 && tab !== 3 && (
													<TableCell>Status</TableCell>
												)}

												{/* {tab !== 1 && tab !== 3 && (
													<TableCell>Block/UnBlock</TableCell>
												)} */}
												
												{tab !== 1 && tab !== 3 && (
                                                    <TableCell>Approve/Reject</TableCell>
                                                )}
 
												
												{/* {tab !== 1 && tab !== 2 && tab !== 3 && (
													<TableCell>Request Type</TableCell>
												)} */}

												{tab !== 1 && tab !== 2 && tab !== 3 && (
													<TableCell>Changes Requested</TableCell>
												)}

												{tab !== 0 && tab !== 1 && (
													<TableCell>Reason</TableCell>
												)}
												<TableCell>Actions</TableCell>
											</tr>
										</TableHeader>
										<VehicleTable
											vehicle={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											tab={tab}
											hideDelete={hideDelete}
											hideEdit={hideEdit}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Vehicles." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default Vehicle;
